import moment from 'moment';

const MIN_DAY_RANGE = 5;

export class BaseGraphTransformer {
    constructor(params) {
        if (!params) {
            throw 'Date params needed!';
        }
        this.graphProps = this.generateBaseProps(params);
    }

    formatMinMaxTickDates(params) {
        const startDate = moment(params.date_start);
        const endDate = moment(params.date_end);
        const dateRange = endDate.diff(startDate, 'days');

        let minDate = moment(params.date_start).format('YYYY-MM-DD');
        let maxDate = moment(params.date_end).format('YYYY-MM-DD');

        if (dateRange < MIN_DAY_RANGE) {
            minDate = moment(params.date_start)
                .subtract(3, 'days')
                .format('YYYY-MM-DD');
            maxDate = moment(params.date_end)
                .add(3, 'days')
                .format('YYYY-MM-DD');
        }

        return {
            minDate,
            maxDate
        };
    }

    getTickValues(params) {
        const startDate = moment(params.date_start);
        const endDate = moment(params.date_end);

        let valuesArray = [];
        const minDate = moment(params.date_start)
            .subtract(3, 'days')
            .format('YYYY-MM-DD');

        valuesArray.push(minDate);
        if (moment(startDate).isSame(endDate)) {
            for (let i = 0; i <= MIN_DAY_RANGE; i++) {
                const newDate = moment(minDate)
                    .add(i + 1, 'days')
                    .format('YYYY-MM-DD');
                valuesArray.push(newDate);
            }
        }

        return valuesArray.length > 1 ? valuesArray : null;
    }

    generateBaseProps(params) {
        return {
            bindToElement: '#chart',
            chartType: '',
            axis: {
                x: {
                    type: 'timeseries',
                    tick: {
                        format: '%Y-%m-%d',
                        fit: false,
                        rotate: 60,
                        values: this.getTickValues(params)
                    },
                    min: this.formatMinMaxTickDates(params).minDate,
                    max: this.formatMinMaxTickDates(params).maxDate
                }
            },
            legend: { show: false },
            grid: { x: { show: true }, y: { show: true } },
            bar: { width: { ratio: 0.1 } },
            point: { focus: { expand: { r: 6 } } },
            color: { pattern: ['#0A0EFF'] }
        };
    }
}



// WEBPACK FOOTER //
// ./src/lib/transformer/BaseGraphTransformer.js